// libs/getTutorials.js

import { db } from "../firebase";
import { collection, query, where, getDocs, updateDoc } from "firebase/firestore";

export async function getTutorialTelas(user) { 
  try {
    const q = query(collection(db, "clientes"), where("email", "==", user.email));
    const querySnapshot = await getDocs(q);
    if (querySnapshot.empty) {
      console.log("Nenhum documento encontrado.");
      return null;
    }
    const dataTutorials = querySnapshot.docs[0].data();
    return dataTutorials.telas;
  } catch (e) {
    console.error("Erro ao buscar dados do tutorial: ", e);
    return null;
  }
}

export async function setTutorial(user, item) {
  try {
    const q = query(collection(db, "clientes"), where("email", "==", user.email));
    const querySnapshot = await getDocs(q);
    if (querySnapshot.empty) {
      console.log("Documento do cliente não encontrado.");
      return;
    }
    const clienteDocRef = querySnapshot.docs[0].ref;
    const clienteData = querySnapshot.docs[0].data();
    const categoria = item.category;
    if (!categoria || !clienteData.telas || !Array.isArray(clienteData.telas[categoria])) {
      console.error(`Erro: O campo 'telas.${categoria}' não é um array ou não existe.`);
      return;
    }
    const telasDaCategoria = clienteData.telas[categoria];
    const telaIndex = telasDaCategoria.findIndex(t => t.value === item.value);
    if (telaIndex !== -1) {
      telasDaCategoria[telaIndex].firstAccess = !telasDaCategoria[telaIndex].firstAccess;
      const updateData = {
        [`telas.${categoria}`]: telasDaCategoria
      };
      await updateDoc(clienteDocRef, updateData);
      console.log('Status do tutorial atualizado com sucesso!');
    } else {
      console.log("Tutorial não encontrado no array de telas.");
    }
  } catch (e) {
    console.error("Erro ao atualizar o tutorial: ", e);
  }
}

export async function setAllTutorialsStatus(user, newStatus) {
  try {
    const q = query(collection(db, "clientes"), where("email", "==", user.email));
    const querySnapshot = await getDocs(q);
    if (querySnapshot.empty) {
      console.log("Documento do cliente não encontrado.");
      return;
    }
    const clienteDocRef = querySnapshot.docs[0].ref;
    const clienteData = querySnapshot.docs[0].data();
    if (!clienteData || !clienteData.telas) {
      console.error("Erro: O campo 'telas' não existe no documento do cliente.");
      return;
    }
    const telas = clienteData.telas;
    const updatedTelas = {};
    for (const categoria in telas) {
      const tutorialsArray = telas[categoria];
      if (Array.isArray(tutorialsArray)) {
        updatedTelas[categoria] = tutorialsArray.map(item => ({
          ...item,
          firstAccess: newStatus
        }));
      }
    }
    await updateDoc(clienteDocRef, {
      telas: updatedTelas
    });
    console.log(`Todos os tutoriais foram ${newStatus ? 'ativados' : 'desativados'} com sucesso!`);
  } catch (e) {
    console.error("Erro ao atualizar todos os tutoriais: ", e);
  }
}